"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _mineralUiTokens = require("mineral-ui-tokens"); // Token has rem units, but our theme variable needs to be in "px"
// Components are built on an 8px grid


var _default = parseFloat(_mineralUiTokens.fontSize_base) * 16 + "px";

exports["default"] = _default;